import styled from 'styled-components';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import Tooltip from 'components/Tooltip';

const InfoButton = styled(({
  className, label, children, offset, altStyle, fullWidth, overlapElementRef,
}) => {
  const [displayReason, setDisplayReason] = useState(false);
  const buttonRef = React.useRef();
  const classes = ['InfoButton'];
  if (className) classes.push(className);
  if (altStyle) classes.push('altStyle');
  if (fullWidth) classes.push('fullWidth');

  return (
    <div className={classes.join(' ')}>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setDisplayReason(!displayReason)}
      >
        <span className="svgIcon"><FontAwesomeIcon icon={faInfoCircle} /></span>
        {label && <span className="label">{label}</span> }
      </button>
      {displayReason && (
        <Tooltip
          offset={offset}
          anchorToRef={buttonRef}
          overlapElementRef={overlapElementRef}
          onClose={() => setDisplayReason(false)}
        >
          {children}
        </Tooltip>
      )}
    </div>
  );
})`
  display: inline-flex;
  &.altStyle {
    color:${({ theme }) => theme.palette.primary.main};
  }
  > button {
    display: inline-flex;
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    margin: 0;
    padding: 0;
    text-align: left;
    color: inherit;
    .label {
      margin-left: 0.5em;
      line-height: 1.4;
    }
  }
  .svgIcon{
    font-size: 1.2em;
  }

  &.fullWidth,
  &.fullWidth >button {
    width: 100%;
  }

`;

export default InfoButton;
